<template>
  <div>
    <el-form v-model="formData" onsubmit="return false;" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_file_name') || '文档名称'
            "
          >
            <b-form-input
              v-model.trim="formData.fileName"
              :placeholder="
                $l('INDEX.form_placeholder_production_order_file_name') ||
                  '请输入文档名称'
              "
              type="search"
              size="sm"
              clearable
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return { formData: {} }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
